<template>
  <div class="token-info-wrapper">
    <div class="token-name-block">
      <TokenIcon
        :class="
          isMobile
            ? 'token-icon-mobile'
            : `token-icon ${
                shouldntBeHighlited ? 'token-icon-no-highlited' : ''
              }`
        "
        :logo="tokenEntity?.logo"
        :size="isMobile ? '20' : '12'"
        :type="tokenEntity?.type"
      />
      <span
        :class="
          isMobile
            ? 'coin-mobile'
            : `coin ${shouldntBeHighlited ? 'noHighlited' : ''}`
        "
      >
        <TextHighlight
          v-if="tokenEntity?.symbol"
          :regexp="searchQuery || ''"
          :text="tokenEntity?.symbol || ''"
        />
      </span>
    </div>
    <span :class="{ 'provider-mobile': isMobile }" class="provider">
      <TextHighlight
        v-if="tokenEntity?.source"
        :regexp="searchQuery || ''"
        :text="providerForToken(tokenEntity as IPersistedToken)"
      />
    </span>
  </div>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';

import { providerForToken } from '@/utils/tokens';

import { TokenIcon } from '@/components/UI/TokenIcon';
import {
  IPersistedToken,
  IPersistedTokenExtended,
  useTablePoolStore,
} from '@/store';
import { TextHighlight } from '@/components/UI/TextHighlight';
import { storeToRefs } from 'pinia';

interface IProps {
  tokenEntity: IPersistedTokenExtended;
  isMobile?: boolean;
  shouldntBeHighlited?: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  isMobile: false,
  shouldntBeHighlited: false,
});

const { tokenEntity, isMobile, shouldntBeHighlited } = toRefs(props);

const { searchQuery } = storeToRefs(useTablePoolStore());
</script>

<style lang="scss" scoped src="./style.scss" />
